import React from 'react';
import {render} from 'react-dom';
import {ThemeProvider} from '@spothero/ui';

import EventWidget from './EventWidget';
import {createCustomTheme, Fonts} from './utils/theme-utils';

window.shEventWidgetInit = affiliateData => {
    render(
        <ThemeProvider
            resetCSS={false}
            theme={{...createCustomTheme({affiliateData})}}
        >
            {affiliateData.fontLink && (
                <Fonts fontLink={affiliateData.fontLink} />
            )}
            <EventWidget affiliateData={affiliateData} />
        </ThemeProvider>,
        document.getElementById('SH-event-widget-root')
    );
};
